import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemButton from "../../components/UIToolkit/SystemButton/SystemButton";
import { useAnnieDisplayName } from "../../hooks/useAnnieAvatar";

type Props = {
	onClick: () => void;
};

/** "Ask Nova" on a focused shift; its own component so the name loads only when Annie can be asked. */
export const FocusedShiftAskAnnieButton: FC<Props> = ({ onClick }) => {
	const { t } = useTranslation();
	const annieName = useAnnieDisplayName();
	return (
		<SystemButton
			buttonVariant="secondary"
			size="small"
			leadingIcon={<AutoAwesomeIcon fontSize="small" />}
			onClick={onClick}
			tooltip={t("employeeChangelog.shiftLineage.focus.annieTooltip", { name: annieName })}
			data-testid="shift-lineage-focus-ask-annie"
			noFullWidthMobile
			sx={{ ml: "auto" }}
		>
			{t("employeeChangelog.shiftLineage.focus.askAnnie", { name: annieName })}
		</SystemButton>
	);
};
